<div class="vertical-center">
  <app-route-page>
    <div class="main-container d-flex flex-row justify-content-center animate-content"
      [ngClass]="{ 'psic-gap-8': isMobile(), 'desktop-gap': !isMobile() }"
      >
      <!-- image container -->
      <img [src]="'assets/images/payment-center.svg'" alt="paymentPortal" />

      <!-- application form container -->
      <div class="d-flex flex-column justify-content-center psic-gap-6 portal-container">
        <div class="d-flex flex-column psic-gap-2 portal-header">
          @if (!selectedChoice()) {
            <p class="subheading-alt">{{globalConstants.welcomeMsg}}</p>
          }
          @if (!isMobile()) {
            <h1>Payment Center</h1>
          }
          @if (isMobile()) {
            <h3>Payment Center</h3>
          }
          @if (!selectedChoice()) {
            <p class="alt-bold">{{globalConstants.paymentCenterSubText}}</p>
          }
        </div>
        <div class="d-flex flex-column psic-gap-8">
          <div class="d-flex flex-column psic-gap-6 reference-type-section">
            @if (!selectedChoice()) {
              <p class="alt">{{ globalConstants.refTypeSubText1 }}</p>
            }
            @if (selectedChoice()) {
              <div class="d-flex flex-row align-items-center psic-gap-2">
                <p class="alt">{{ globalConstants.refTypeSubText2 }}</p>
                <mat-icon class="psic-px-1 mat-icon-32" [svgIcon]="'info-circle'" (click)="onHelpIconClick()"></mat-icon>
              </div>
            }
            <div class="mat-chip-container caption-bold">
              <mat-chip-listbox
                aria-label="Type selection"
                class="d-flex flex-row"
                [selectable]="true"
                [multiple]="false"
                >
                @for (pill of pills; track pill) {
                  <mat-chip-option
                    class="mat-chip-item"
                    [color]="pill.selected ? 'primary' : 'accent'"
                    (click)="onSelectChoice(pill,true)"
                    [selected]="pill.selected"
                    >
                    {{ pill.type }}
                  </mat-chip-option>
                }
              </mat-chip-listbox>
            </div>
          </div>
          @if (selectedChoice()) {
            <div class="d-flex flex-column">
              <form [formGroup]="form">
                <lib-input-text
                  floatLabel="auto"
                  [field]="referenceNumberField"
                  [formControlName]="referenceNumberField.name"
                ></lib-input-text>
                <lib-input-text
                  floatLabel="auto"
                  [field]="zipCodeField"
                  [formControlName]="zipCodeField.name"
                ></lib-input-text>
              </form>
            </div>
          }
          @if (selectedChoice()) {
            <div class="d-flex flex-column">
              <form [formGroup]="reactiveForm">
                <re-captcha
                  formControlName="recaptchaReactive"
                  (resolved)="resolved($event)"
                  >
                </re-captcha>
                @if (reactiveForm.controls['recaptchaReactive'].invalid && (reactiveForm.controls['recaptchaReactive'].touched || showErrorMsg())) {
                  <div class="required">
                    {{ globalConstants.recaptchreqired }}
                  </div>
                }
              </form>
            </div>
          }
          <div class="button-wrapper">
            <lib-button
              buttonSize="large"
              buttonText="continue"
              [disabled]="!form.valid || !reactiveForm.valid"
              (click)="retrievePolicyDetail()"
            ></lib-button>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center psic-gap-2 login-section">
          <p class="disclaimer" [innerHTML]="globalConstants.loginMsg">{{globalConstants.loginMsg}}</p>
          <lib-button
            [buttonText]="'Login'"
            [buttonType]="'borderless'"
            (click) = "login()"
          ></lib-button>
        </div>
        <div class="d-flex flex-row align-items-center psic-gap-2 login-section">
          <p class="alt error-90-color"><I><b>Note: </b>{{globalConstants.clearCacheMsg}}</I></p>
        </div>
      </div>
    </div>
  </app-route-page>
</div>
